import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(auth)/magic/magic-form.tsx");
